import { render, staticRenderFns } from "./PiperunConfigCard.vue?vue&type=template&id=703c0298&"
import script from "./PiperunConfigCard.vue?vue&type=script&lang=ts&"
export * from "./PiperunConfigCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports